// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__x8kGI","label":"default_label__oujTL","fields":"default_fields__I-ajO","field":"default_field__HdbAU","separator":"default_separator__fQl0N"};